import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import http from './utils/http'
import I18Lang from './components/I18Lang'
import SlideVerify from 'vue-monoplasty-slide-verify'
import '@assets/css/varibles.scss'
import '@assets/css/common.scss'
import '@assets/css/reset.scss'
import i18n from './utils/i18n'
import Element from 'element-ui'
import { redirectMobilePcUserCenterToH5 } from './utils/deviceRedirect'

import VueClipboard from 'vue-clipboard2'

Vue.component('I18Lang', I18Lang)

Vue.prototype.$loading = Element.Loading.service
Vue.prototype.$msgbox = Element.MessageBox
Vue.prototype.$alert = Element.MessageBox.alert
Vue.prototype.$confirm = Element.MessageBox.confirm
Vue.prototype.$prompt = Element.MessageBox.prompt
Vue.prototype.$notify = Element.Notification
Vue.prototype.$message = Element.Message
Vue.prototype.$http = http
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

Vue.use(SlideVerify)

Vue.prototype.$format = function (value, format) {
  if (value === 0 || value === '0' || !value) {
    return '-'
  }
  var time = new Date(parseInt((value + '000').substr(0, 13)))
  var tpl = format || 'YY-MM-DD hh:mm:ss'
  tpl = tpl.replace('YY', time.getFullYear())
  tpl = tpl.replace('MM', ('00' + (time.getMonth() + 1)).substr(-2, 2))
  tpl = tpl.replace('DD', ('00' + time.getDate()).substr(-2, 2))
  tpl = tpl.replace('hh', ('00' + time.getHours()).substr(-2, 2))
  tpl = tpl.replace('mm', ('00' + time.getMinutes()).substr(-2, 2))
  tpl = tpl.replace('ss', ('00' + time.getSeconds()).substr(-2, 2))
  return tpl
}

// 格式化
Vue.filter('format', Vue.prototype.$format)

Vue.config.productionTip = false

Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
})

// 手机访问 PC 用户中心时，直接使用 H5 用户中心。
const redirectedToH5 = redirectMobilePcUserCenterToH5()

if (!redirectedToH5) {
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')
}
